import {Pressable, StyleSheet, View} from 'react-native'
import {type ChatBskyActorDefs} from '@atproto/api'

import {useChatBubbleDispatch} from '#/state/chat-bubble'
import {UserAvatar} from '#/view/com/util/UserAvatar'
import {atoms as a, useTheme} from '#/alf'
import {Text} from '#/components/Typography'

export function FloatingChatHeader({
  windowId,
  recipientProfile,
  isMinimized,
}: {
  windowId: string
  recipientProfile?: ChatBskyActorDefs.ProfileViewBasic
  isMinimized: boolean
}) {
  const t = useTheme()
  const dispatch = useChatBubbleDispatch()

  const displayName =
    recipientProfile?.displayName || recipientProfile?.handle || 'Chat'

  return (
    <View
      style={[
        styles.header,
        {
          backgroundColor: t.palette.primary_500,
        },
      ]}>
      <Pressable
        style={styles.headerLeft}
        onPress={() =>
          dispatch({
            type: isMinimized ? 'RESTORE_CHAT' : 'MINIMIZE_CHAT',
            windowId,
          })
        }>
        <UserAvatar
          type="user"
          size={24}
          avatar={recipientProfile?.avatar}
        />
        <Text
          style={[a.text_sm, a.font_bold, {color: '#fff'}]}
          numberOfLines={1}>
          {displayName}
        </Text>
      </Pressable>
      <View style={styles.headerActions}>
        <Pressable
          accessibilityRole="button"
          accessibilityLabel="Minimize"
          onPress={() =>
            dispatch({
              type: isMinimized ? 'RESTORE_CHAT' : 'MINIMIZE_CHAT',
              windowId,
            })
          }
          style={({hovered}: any) => [
            styles.headerButton,
            hovered && {backgroundColor: 'rgba(255,255,255,0.2)'},
          ]}>
          <Text style={{color: '#fff', fontSize: 16, lineHeight: 16}}>
            {isMinimized ? '▲' : '▼'}
          </Text>
        </Pressable>
        <Pressable
          accessibilityRole="button"
          accessibilityLabel="Close"
          onPress={() => dispatch({type: 'CLOSE_CHAT', windowId})}
          style={({hovered}: any) => [
            styles.headerButton,
            hovered && {backgroundColor: 'rgba(255,255,255,0.2)'},
          ]}>
          <Text style={{color: '#fff', fontSize: 16, lineHeight: 16}}>
            ✕
          </Text>
        </Pressable>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    cursor: 'pointer',
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flex: 1,
    overflow: 'hidden',
  },
  headerActions: {
    flexDirection: 'row',
    gap: 2,
  },
  headerButton: {
    width: 28,
    height: 28,
    borderRadius: 14,
    alignItems: 'center',
    justifyContent: 'center',
  },
})
